// Warn user when trying to refresh/leave the page
export const onBeforeUnloadListener = (e: Event) => {
  // @ts-ignore
  (e || window.event).returnValue = null; // Gecko + IE

  return null; // Webkit, Safari, Chrome
};
